// extracted by mini-css-extract-plugin
module.exports = {"wrapper__marker":"DealerMarker_wrapper__marker__37-oV","markerIcon":"DealerMarker_markerIcon__2HoJ5"};